<template>
  <div class="hy-piao">
    <div class="title">
      <h5>开具发票份数设置</h5>
    </div>
    <div class="typelist">
     <div class="Myunmber">
        <p>发票总额</p>
        <p class="num">
          <b>{{checkbox.allAmount}}</b>元
        </p>
     </div>
      <div class="fenbox">
        <span>发票总数<i>{{typelist.length}}</i>份</span>
        <van-button type="info" @click="addNum">增加发票</van-button>
      </div>
      <!-- 循环字段-->
      <div v-for="(items,index) in typelist" :key="index">
        <!-- 文本输入框-->
        <van-field  v-model="typelist[index].num" :label="'发票金额 '+(index+1)" placeholder="输入金额" type="number" @blur="onBlur(index)">
          <template #button v-if="items.btn">
            <van-button size="small" type="danger" @click="remove(index)">移除</van-button>
          </template>
        </van-field>
      </div>
    </div>
    <div class="addPiaoBtnbox">
      <span class="addPiaoBtn" @click="addPiaoBtn"> 确认设置 </span>
    </div>
  </div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        typelist: [
          {
            num:'',
            btn:false,
          },
        ],
        checkbox: {},
      };
    },
    created: function() {
      var _this = this;
      var local = JSON.parse(localStorage.getItem('invoiceMenu'));
      _this.checkbox = local;
      var piao_data = JSON.parse(localStorage.getItem('piao_data'));
      if(piao_data){
        _this.typelist = piao_data;
      }
    },
    methods: {
      onBlur(i) {
        // 过滤输入的数字
        var _this = this;
        var num = Number(_this.typelist[i].num);
        _this.typelist[i].num = num.toFixed(2);
      },
      remove(i) {
        var _this = this;
       _this.typelist.splice(i,1);
      },
      addNum(){
        var _this = this;
        _this.typelist.push(
          {
            num:'',
            btn:true,
          });
      },
      //提交开票信息
      addPiaoBtn() {
        var _this = this;
        var nums = 0;
        for(var i = 0;i<_this.typelist.length;i++){
          if(_this.typelist[i].num == ''){
            _this.$toast('请输入发票 '+(i+1)+' 金额');
            return false;
          }else if(_this.typelist[i].num == '0.00'){
            _this.$toast('发票金额不能为 0');
            return false;
          }else{
            nums+= parseFloat(_this.typelist[i].num)
          }
        }
        if(nums > _this.checkbox.allAmount){
          _this.$toast('开票总金额不能大于发票金额！ ');
        }else if(nums < _this.checkbox.allAmount){
          _this.$dialog.confirm({
            title: '温馨提示',
            message: '当前发票金额小于发票总额，是否确认继续？',
          })
            .then(() => {
            // on confirm
            localStorage.setItem('piao_data',JSON.stringify(_this.typelist));
            _this.$router.go(-1);
          })
            .catch(() => {
            // on cancel

          });
        }else{
          localStorage.setItem('piao_data',JSON.stringify(_this.typelist));
          _this.$router.go(-1);
        }

      }
    },
    mounted() {}
  }
</script>
<style lang="less">
  .hy-piao {
    .typelist {
      width: 100%;
      background: #FFF;
      .fenbox{
        line-height: 100px;
        border: 20px solid #F7F7F7;
        border-left: none;
        border-right:none;
        padding: 0 25px;
        overflow: hidden;
        span{
          font-size: 28px;
          i{
            color: #ee0a24;
            padding: 0 10px;
            display: inline-block;
            font-style: inherit;
          }
        }
        .van-button{
          float: right;
          height: 60px;
          margin:20px 0px;
          font-size: 24px;
          .van-button__text{
            font-size: 24px;
          }
        }
      }
      .Myunmber{
        width: 100%;
        padding: 30px;
        border-bottom: 1px solid #EBEBEB;
        p{
          font-size: 24px;
          text-align: center;
        }
        .num{
          font-size: 24px;
          text-align: center;
          line-height: 80px;
          b{
            font-size: 45px;
            color: #ee0a24;
            padding: 0 10px;
          }
        }
      }
    }
  }
</style>
